import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Collapse, ListItem } from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';

class CollapsableListItem extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: props.isOpen,
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  render() {
    const { listItemText, listItemIcon, nestedList, listItemClass } = this.props;
    const { isOpen } = this.state;

    return (
      <div>
        <ListItem button onClick={this.handleClick} className={listItemClass}>
          {listItemIcon}
          {listItemText}
          {isOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={isOpen} timeout="auto" unmountOnExit>
          {nestedList}
        </Collapse>
      </div>
    );
  }
}

export default CollapsableListItem;

CollapsableListItem.propTypes = {
  listItemText: PropTypes.object,
  listItemIcon: PropTypes.object,
  nestedList: PropTypes.object,
  listItemClass: PropTypes.string,
  isOpen: PropTypes.bool,
};

CollapsableListItem.defaultProps = {
  listItemText: null,
  listItemIcon: null,
  nestedList: null,
  listItemClass: '',
  isOpen: false,
};



// WEBPACK FOOTER //
// ./src/components/CollapsableListItem.js